import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-save-edit',
  templateUrl: './save-edit.component.html',
  styleUrls: ['./save-edit.component.scss']
})
export class SaveEditComponent implements OnInit {
  @Input() isEdit: boolean;
  @Input() isEditVisible: boolean;
  @Input() saving: boolean;
  @Input() disable: boolean;
  @Input() form: any; // Adjust the type based on your form structure
  @Input() data: any;
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<any>();

  private modalService = inject(NgbModal);

  originalData: any;

  ngOnInit(): void {
    console.log('SaveEditComponent loaded!');
    if (this.data) {
      this.originalData = { ...this.data };
    }
  }

  onSave(): void {
    if (this.data) {
      this.originalData = { ...this.data };
    }
    this.save.emit();
  }

  toggleEdit(): void {
    this.isEdit = !this.isEdit;
  }

  cancelEdit(): void {
    // Confirm dialog logic
    if (this.form && (this.form.dirty || this.form.invalid || this.form.modified)) {
      const modalRef = this.modalService.open(ConfirmDialogComponent);
      modalRef.componentInstance.title = 'Cancel the changes';
      modalRef.componentInstance.message = 'Are you sure you want to cancel the changes?';

      modalRef.result.then(result => {
        if (result) {
          this.isEdit = false;
          this.form.reset();
          if (this.originalData) {
            this.data = { ...this.originalData };
            this.cancel.emit(this.originalData);
          } else {
            this.cancel.emit({});
          }
        }
      });
    } else {
      this.isEdit = !this.isEdit;
    }
  }
}
